import { Outlet, useLocation } from 'react-router-dom';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { MASTER_DATA_CHILDREN } from '../../layout/navItems';

/** The Master Data pages. Navigation between them lives in the sidebar's
 * Master Data submenu (the single list in navItems.ts) — this only shows
 * where you are. */
export const MasterDataLayout = () => {
  const location = useLocation();
  const current = MASTER_DATA_CHILDREN.find((child) => location.pathname.startsWith(child.path));

  return (
    <Box>
      <Box sx={{ px: 3, pt: 2 }}>
        <Breadcrumbs aria-label="Master Data location">
          <Typography color="text.secondary" variant="body2">
            Master Data
          </Typography>
          {current && (
            <Typography color="text.primary" variant="body2" fontWeight={600}>
              {current.label}
            </Typography>
          )}
        </Breadcrumbs>
      </Box>
      <Outlet />
    </Box>
  );
};
